











import Vue from "vue";
import AppBar from "@/components/AppBar.vue";
import AddWebsiteModal from "@/components/AddWebsiteModal.vue";

export default Vue.extend({
  name: "Dashboard",

  components: {
    AppBar,
    AddWebsiteModal,
  },

  data() {
    return {
      showAddWebsiteModal: false,
    };
  },

  methods: {
    onWebsiteAdd(settings: object) {
      console.warn({ ...settings });
    },
  },
});
